import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy, tick } from 'svelte';
import * as pipelineModel from '../../../../features/pipeline/pipeline-model.ts';
import { drawParamPreviewSphereCpu } from '../../../../platforms/browser/step-preview-cpu-render.ts';
import { getLanguage, subscribeLanguageChange, t } from '../../i18n.ts';
import Button from '../svelte-button.svelte';
import { PARAM_PREVIEW_SIZE, PARAM_PREVIEW_TARGETS } from './shared.ts';

var root = $.from_html(`<span data-part="param-group-badge" class="svelte-4ciwqv"> </span>`);
var root_1 = $.from_html(`<button type="button" class="param-socket svelte-4ciwqv" data-param-socket="true"><span data-part="socket-dot" aria-hidden="true" class="svelte-4ciwqv"></span> <span data-part="param-name" class="svelte-4ciwqv"> </span> <span data-part="param-desc" class="svelte-4ciwqv"> </span></button>`);
var root_2 = $.from_html(`<section class="svelte-4ciwqv"><header data-part="param-group-head" class="svelte-4ciwqv"><div data-part="param-group-title-row" class="svelte-4ciwqv"><div data-part="param-group-title" class="svelte-4ciwqv"> </div> <!></div> <div data-part="param-group-desc" class="svelte-4ciwqv"> </div></header> <div data-part="param-group-nodes" class="svelte-4ciwqv"></div></section>`);
var root_3 = $.from_html(`<div class="custom-param-item svelte-4ciwqv" data-param-socket="true" data-custom-param-item="true"><span data-part="socket-dot" aria-hidden="true" class="svelte-4ciwqv"></span> <div data-part="custom-param-header" data-socket-drag-ignore="true" class="svelte-4ciwqv"><button type="button" class="custom-param-handle svelte-4ciwqv" data-socket-drag-ignore="true" data-custom-param-handle="true"><span data-part="custom-param-grip" aria-hidden="true" class="svelte-4ciwqv"></span></button> <input class="custom-param-input svelte-4ciwqv" data-socket-drag-ignore="true"/> <!></div> <div data-part="custom-param-meta" class="svelte-4ciwqv"><span data-part="param-desc" class="svelte-4ciwqv"> </span></div> <div data-part="custom-param-slider-row" data-socket-drag-ignore="true" class="svelte-4ciwqv"><input type="range" class="custom-param-range svelte-4ciwqv" data-socket-drag-ignore="true" min="0" max="1" step="0.01"/> <span data-part="custom-param-value" class="svelte-4ciwqv"> </span></div></div>`);
var root_4 = $.from_html(`<span class="tooltip svelte-4ciwqv" role="tooltip"><span class="tooltip-label svelte-4ciwqv"> </span> <canvas class="tooltip-canvas svelte-4ciwqv"></canvas></span>`);
var root_5 = $.from_html(`<div class="param-root svelte-4ciwqv"><!> <section data-param-group="custom-params" data-param-group-tone="default" class="svelte-4ciwqv"><header data-part="param-group-head" class="svelte-4ciwqv"><div data-part="param-group-title-row" class="svelte-4ciwqv"><div data-part="param-group-title" class="svelte-4ciwqv">Custom Params</div></div> <div data-part="param-group-desc" class="svelte-4ciwqv"> </div></header> <div data-part="param-group-nodes" class="svelte-4ciwqv"><!> <!></div></section> <!></div>`);

const $$css = {
	hash: 'svelte-4ciwqv',
	code: '.param-root.svelte-4ciwqv {display:flex;flex-direction:column;gap:12px;}[data-param-group].svelte-4ciwqv {border:1px solid var(--color-line);border-radius:14px;padding:10px;background:color-mix(in srgb, var(--color-panel), var(--color-bg) 12%);}[data-param-group-tone="feedback"].svelte-4ciwqv {border-color:var(--color-feedback-border, var(--color-accent));background:linear-gradient(180deg, color-mix(in srgb, var(--color-accent), transparent 92%), color-mix(in srgb, var(--color-accent), transparent 98%)),\n      color-mix(in srgb, var(--color-panel), var(--color-bg) 8%);box-shadow:inset 0 0 0 1px color-mix(in srgb, var(--color-accent), transparent 92%);}[data-part="param-group-head"].svelte-4ciwqv {margin-bottom:8px;}[data-part="param-group-title-row"].svelte-4ciwqv {display:flex;align-items:center;justify-content:space-between;gap:8px;}[data-part="param-group-title"].svelte-4ciwqv {font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:var(--color-text-strong);}[data-part="param-group-badge"].svelte-4ciwqv {display:inline-flex;align-items:center;height:20px;padding:0 8px;border-radius:999px;border:1px solid var(--color-feedback-badge-border, var(--color-accent));background:var(--color-feedback-badge-bg, color-mix(in srgb, var(--color-accent), transparent 88%));color:var(--color-feedback-badge-text, var(--color-accent));font-size:10px;font-weight:700;}[data-part="param-group-desc"].svelte-4ciwqv {margin-top:4px;font-size:11px;line-height:1.45;color:var(--color-muted);}[data-part="param-group-nodes"].svelte-4ciwqv {display:flex;flex-direction:column;gap:9px;}.param-socket.svelte-4ciwqv,\n  .custom-param-item.svelte-4ciwqv {position:relative;width:100%;text-align:left;border:1px solid var(--color-line);border-radius:10px;background:color-mix(in srgb, var(--color-panel), var(--color-bg) 10%);color:var(--color-text);padding:10px 34px 10px 10px;min-height:54px;transition:120ms ease;}.param-socket.svelte-4ciwqv {display:flex;flex-direction:column;justify-content:center;gap:3px;cursor:pointer;user-select:none;}.param-socket.svelte-4ciwqv:hover,\n  .param-socket.svelte-4ciwqv:focus-visible,\n  .custom-param-item.svelte-4ciwqv:hover,\n  .custom-param-item.svelte-4ciwqv:focus-within {border-color:var(--color-accent);transform:translateY(-1px);}.custom-param-item.svelte-4ciwqv {display:flex;flex-direction:column;gap:8px;align-items:stretch;cursor:grab;padding-right:10px;}[data-custom-param-item="true"][data-dragging="true"] {opacity:0.42;}[data-custom-param-item="true"][data-drop-position="before"] {box-shadow:inset 0 3px 0 var(--color-accent);}[data-custom-param-item="true"][data-drop-position="after"] {box-shadow:inset 0 -3px 0 var(--color-accent);}[data-part="socket-dot"].svelte-4ciwqv {position:absolute;top:50%;right:8px;width:10px;height:10px;border-radius:50%;border:2px solid var(--color-socket-border, var(--color-accent));background:var(--color-socket-bg, var(--color-panel));transform:translateY(-50%);pointer-events:none;}[data-part="param-name"].svelte-4ciwqv {font-size:12px;font-weight:700;color:var(--color-text-strong);}[data-part="param-desc"].svelte-4ciwqv {font-size:11px;color:var(--color-muted);}[data-part="custom-param-header"].svelte-4ciwqv,\n  [data-part="custom-param-slider-row"].svelte-4ciwqv {display:grid;align-items:center;grid-template-columns:auto 1fr auto;gap:4px;width:100%;min-width:0;}[data-part="custom-param-meta"].svelte-4ciwqv {display:flex;align-items:center;justify-content:space-between;gap:8px;min-width:0;}.custom-param-handle.svelte-4ciwqv {display:inline-flex;align-items:center;justify-content:center;align-self:stretch;min-width:8px;padding:0;border:none;background:transparent;color:var(--color-muted);cursor:grab;}.custom-param-handle.svelte-4ciwqv:active {cursor:grabbing;}[data-part="custom-param-grip"].svelte-4ciwqv {width:8px;height:18px;opacity:0.9;background-image:radial-gradient(circle, currentColor 1.1px, transparent 1.2px),\n      radial-gradient(circle, currentColor 1.1px, transparent 1.2px);background-position:0 0, 4px 0;background-size:4px 6px;background-repeat:repeat-y;}.custom-param-input.svelte-4ciwqv {min-width:0;width:100%;padding:4px 6px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--color-text-strong);font-size:12px;font-weight:700;}.custom-param-input.svelte-4ciwqv:hover {border-color:color-mix(in srgb, var(--color-line), var(--color-accent) 32%);background:color-mix(in srgb, var(--color-panel), var(--color-bg) 10%);}.custom-param-input.svelte-4ciwqv:focus {outline:none;border-color:var(--color-accent);background:color-mix(in srgb, var(--color-panel), var(--color-bg) 6%);}.custom-param-range.svelte-4ciwqv {width:100%;accent-color:var(--color-accent);}[data-part="custom-param-value"].svelte-4ciwqv {min-width:32px;text-align:right;font-size:11px;font-variant-numeric:tabular-nums;color:var(--color-text-strong);}.add-param-button {width:100%;justify-content:center;}.tooltip.svelte-4ciwqv {position:fixed;transform:translateY(-50%);display:flex;flex-direction:column;gap:6px;padding:10px;border-radius:12px;border:1px solid color-mix(in srgb, var(--color-line), var(--color-text-strong) 12%);background:color-mix(in srgb, var(--color-panel), var(--color-bg) 18%);box-shadow:0 12px 28px color-mix(in srgb, var(--color-bg), transparent 72%);z-index:20;pointer-events:none;}.tooltip-label.svelte-4ciwqv {font-size:10px;line-height:1.2;letter-spacing:0.04em;color:var(--color-muted);}.tooltip-canvas.svelte-4ciwqv {width:112px;height:112px;display:block;border-radius:8px;background:radial-gradient(circle at 50% 42%, color-mix(in srgb, var(--color-text-strong), transparent 88%), transparent 58%),\n      color-mix(in srgb, var(--color-panel), var(--color-bg) 32%);}'
};

export default function Svelte_param_node_list($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const materialSettings = $.prop($$props, 'materialSettings', 23, () => pipelineModel.DEFAULT_MATERIAL_SETTINGS),
		customParams = $.prop($$props, 'customParams', 23, () => []);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let language = $.state($.proxy(getLanguage()));
	let previewState = $.state(null);
	let previewCanvas = $.state(null);

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function portal(node) {
		if (typeof document === 'undefined') {
			return {
				destroy() {
					return undefined;
				}
			};
		}

		document.body.appendChild(node);

		return {
			destroy() {
				if (node.parentNode) {
					node.parentNode.removeChild(node);
				}
			}
		};
	}

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	function isPreviewTarget(param) {
		return PARAM_PREVIEW_TARGETS.has(param);
	}

	function drawPreview(param) {
		if (!$.get(previewCanvas) || !isPreviewTarget(param)) {
			return;
		}

		try {
			drawParamPreviewSphereCpu({
				canvas: $.get(previewCanvas),
				param,
				pixelWidth: PARAM_PREVIEW_SIZE,
				pixelHeight: PARAM_PREVIEW_SIZE,
				materialSettings: materialSettings(),
				lightDirection: pipelineModel.STEP_PREVIEW_LIGHT_DIR,
				viewDirection: pipelineModel.STEP_PREVIEW_VIEW_DIR
			});
		} catch(error) {
			const message = error instanceof Error ? error.message : tr('common.unknownError');

			dispatch('status-message', {
				message: tr('pipeline.status.paramPreviewDrawFailed', { message }),
				kind: 'error'
			});
		}
	}

	function hidePreview() {
		$.set(previewState, null);
		$.set(previewCanvas, null);
	}

	function updatePreviewPosition(anchor, param) {
		const rect = anchor.getBoundingClientRect();
		const previewWidth = PARAM_PREVIEW_SIZE + 20;
		const previewHeight = PARAM_PREVIEW_SIZE + 38;
		let left = rect.right + 10;
		let top = rect.top + rect.height * 0.5;

		if (left + previewWidth > window.innerWidth - 12) {
			left = Math.max(12, rect.left - previewWidth - 10);
		}

		if (top + previewHeight * 0.5 > window.innerHeight - 12) {
			top = window.innerHeight - 12 - previewHeight * 0.5;
		}

		if (top - previewHeight * 0.5 < 12) {
			top = 12 + previewHeight * 0.5;
		}

		$.set(previewState, { param, left, top }, true);
	}

	async function showPreview(param, anchor) {
		if (!isPreviewTarget(param)) {
			return;
		}

		updatePreviewPosition(anchor, param);
		await tick();

		if ($.get(previewState)?.param === param) {
			drawPreview(param);
		}
	}

	function syncActivePreviewPosition() {
		if (!$.get(previewState)) {
			return;
		}

		const anchor = document.querySelector(`[data-param-socket="true"][data-param="${$.get(previewState).param}"]`);

		if (!(anchor instanceof HTMLElement)) {
			hidePreview();

			return;
		}

		updatePreviewPosition(anchor, $.get(previewState).param);
	}

	function handleValueSliderInput(paramId, event) {
		const target = event.currentTarget;

		if (!target) {
			return;
		}

		dispatch('set-custom-param-value', { paramId, value: Number(target.value), recordHistory: false });
	}

	function handleValueSliderWheel(customParam, event) {
		const delta = event.deltaY < 0 ? 0.01 : -0.01;
		const nextValue = Math.max(0, Math.min(1, customParam.defaultValue + delta));

		dispatch('set-custom-param-value', { paramId: customParam.id, value: nextValue });
		event.preventDefault();
	}

	onDestroy(() => {
		disposeLanguageSync();
	});

	var $$exports = {
		get materialSettings() {
			return materialSettings();
		},

		set materialSettings($$value = pipelineModel.DEFAULT_MATERIAL_SETTINGS) {
			materialSettings($$value);
			$.flush();
		},

		get customParams() {
			return customParams();
		},

		set customParams($$value = []) {
			customParams($$value);
			$.flush();
		}
	};

	var fragment = $.comment();

	$.event('scroll', $.window, syncActivePreviewPosition);
	$.event('resize', $.window, syncActivePreviewPosition);

	var node_1 = $.first_child(fragment);

	$.key(node_1, () => $.get(language), ($$anchor) => {
		var div = root_5();
		var node_2 = $.child(div);

		$.each(node_2, 17, () => pipelineModel.PARAM_GROUPS, (group) => group.key, ($$anchor, group) => {
			var section = root_2();
			var header = $.child(section);
			var div_1 = $.child(header);
			var div_2 = $.child(div_1);
			var text = $.only_child(div_2, true);
			var node_3 = $.sibling(div_2, 2);

			{
				var consequent = ($$anchor) => {
					var span = root();
					var text_1 = $.only_child(span, true);

					$.template_effect(($0) => $.set_text(text_1, $0), [() => tr('pipeline.paramGroup.prevColorBadge')]);
					$.append($$anchor, span);
				};

				$.if(node_3, ($$render) => {
					if ($.get(group).tone === 'feedback') $$render(consequent);
				});
			}

			$.reset(div_1);

			var div_3 = $.sibling(div_1, 2);
			var text_2 = $.only_child(div_3, true);

			$.reset(header);

			var div_4 = $.sibling(header, 2);

			$.each(div_4, 20, () => $.get(group).params, (paramName) => paramName, ($$anchor, paramName) => {
				const param = $.derived(() => pipelineModel.getParamDef(paramName));
				var button = root_1();
				var span_1 = $.sibling($.child(button), 2);
				var text_3 = $.only_child(span_1, true);
				var span_2 = $.sibling(span_1, 2);
				var text_4 = $.only_child(span_2, true);

				$.reset(button);

				$.template_effect(
					($0, $1, $2) => {
						$.set_attribute(button, 'data-param', $.get(param).key);
						$.set_attribute(button, 'title', $0);
						$.set_attribute(button, 'aria-label', $1);
						$.set_attribute(button, 'aria-describedby', $2);
						$.set_text(text_3, $.get(param).label);
						$.set_text(text_4, $.get(param).description);
					},
					[
						() => isPreviewTarget($.get(param).key)
							? undefined
							: tr('pipeline.param.connectTitle', { label: $.get(param).label }),
						() => tr('pipeline.param.connectTitle', { label: $.get(param).label }),
						() => isPreviewTarget($.get(param).key) ? `param-preview-${$.get(param).key}` : undefined
					]
				);

				$.event('mouseenter', button, (event) => void showPreview($.get(param).key, event.currentTarget));
				$.event('mouseleave', button, hidePreview);
				$.event('focus', button, (event) => void showPreview($.get(param).key, event.currentTarget));
				$.event('blur', button, hidePreview);
				$.append($$anchor, button);
			});

			$.reset(div_4);
			$.reset(section);

			$.template_effect(
				($0) => {
					$.set_attribute(section, 'data-param-group', $.get(group).key);
					$.set_attribute(section, 'data-param-group-tone', $.get(group).tone);
					$.set_text(text, $.get(group).label);
					$.set_text(text_2, $0);
				},
				[() => tr($.get(group).descriptionKey)]
			);

			$.append($$anchor, section);
		});

		var section_1 = $.sibling(node_2, 2);
		var header_1 = $.child(section_1);
		var div_5 = $.sibling($.child(header_1), 2);
		var text_5 = $.only_child(div_5, true);

		$.reset(header_1);

		var div_6 = $.sibling(header_1, 2);
		var node_4 = $.child(div_6);

		$.each(node_4, 17, customParams, (customParam) => customParam.id, ($$anchor, customParam) => {
			var div_7 = root_3();
			var div_8 = $.sibling($.child(div_7), 2);
			var button_1 = $.child(div_8);

			$.set_attribute(button_1, 'draggable', true);

			var input = $.sibling(button_1, 2);

			$.remove_input_defaults(input);

			var node_5 = $.sibling(input, 2);

			Button(node_5, {
				variant: ["destructive", "small"],
				className: 'custom-param-remove',
				handlePress: () => dispatch('remove-custom-param', { paramId: $.get(customParam).id }),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_6 = $.text();

					$.template_effect(($0) => $.set_text(text_6, $0), [() => tr('pipeline.param.remove')]);
					$.append($$anchor, text_6);
				},
				$$slots: { default: true }
			});

			$.reset(div_8);

			var div_9 = $.sibling(div_8, 2);
			var span_3 = $.child(div_9);
			var text_7 = $.only_child(span_3, true);

			$.reset(div_9);

			var div_10 = $.sibling(div_9, 2);
			var input_1 = $.child(div_10);

			$.remove_input_defaults(input_1);

			var span_4 = $.sibling(input_1, 2);
			var text_8 = $.only_child(span_4, true);

			$.reset(div_10);
			$.reset(div_7);

			$.template_effect(
				($0, $1, $2) => {
					$.set_attribute(div_7, 'data-param-id', $.get(customParam).id);
					$.set_attribute(div_7, 'data-param', $0);
					$.set_attribute(div_7, 'aria-label', `Connect ${$.get(customParam).label}`);
					$.set_attribute(div_7, 'title', `Connect ${$.get(customParam).label}`);
					$.set_attribute(button_1, 'aria-label', `Reorder ${$.get(customParam).label}`);
					$.set_value(input, $.get(customParam).label);
					$.set_attribute(input, 'maxlength', pipelineModel.MAX_CUSTOM_PARAM_LABEL_LENGTH);
					$.set_attribute(input, 'aria-label', `Custom param label ${$.get(customParam).id}`);
					$.set_text(text_7, `u_param_${$.get(customParam).id}`);
					$.set_value(input_1, $1);
					$.set_text(text_8, $2);
				},
				[
					() => pipelineModel.buildCustomParamRef($.get(customParam).id),
					() => String($.get(customParam).defaultValue),
					() => $.get(customParam).defaultValue.toFixed(2)
				]
			);

			$.delegated('pointerdown', button_1, (event) => event.stopPropagation());

			$.event('blur', input, (event) => dispatch('rename-custom-param', {
				paramId: $.get(customParam).id,
				label: event.currentTarget.value
			}));

			$.delegated('input', input_1, (event) => handleValueSliderInput($.get(customParam).id, event));
			$.delegated('change', input_1, () => dispatch('commit-custom-param-value-change'));
			$.event('wheel', input_1, (event) => handleValueSliderWheel($.get(customParam), event));
			$.append($$anchor, div_7);
		});

		var node_6 = $.sibling(node_4, 2);

		Button(node_6, {
			variant: 'secondary',
			className: 'add-param-button',
			handlePress: () => dispatch('add-custom-param'),
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_9 = $.text();

				$.template_effect(($0) => $.set_text(text_9, $0), [() => tr('pipeline.param.add')]);
				$.append($$anchor, text_9);
			},
			$$slots: { default: true }
		});

		$.reset(div_6);
		$.reset(section_1);

		var node_7 = $.sibling(section_1, 2);

		{
			var consequent_1 = ($$anchor) => {
				var span_5 = root_4();
				var span_6 = $.child(span_5);
				var text_10 = $.only_child(span_6, true);
				var canvas = $.sibling(span_6, 2);

				$.bind_this(canvas, ($$value) => $.set(previewCanvas, $$value), () => $.get(previewCanvas));
				$.reset(span_5);
				$.action(span_5, ($$node) => portal?.($$node));

				$.template_effect(
					($0, $1) => {
						$.set_attribute(span_5, 'id', `param-preview-${$.get(previewState).param}`);
						$.set_attribute(span_5, 'aria-label', $0);
						$.set_style(span_5, `left:${$.get(previewState).left}px;top:${$.get(previewState).top}px;`);
						$.set_text(text_10, $1);
						$.set_attribute(canvas, 'width', PARAM_PREVIEW_SIZE);
						$.set_attribute(canvas, 'height', PARAM_PREVIEW_SIZE);
					},
					[
						() => tr('pipeline.param.previewTooltip', {
							label: pipelineModel.getParamDef($.get(previewState).param).label
						}),
						() => tr('pipeline.param.previewScale')
					]
				);

				$.append($$anchor, span_5);
			};

			$.if(node_7, ($$render) => {
				if ($.get(previewState)) $$render(consequent_1);
			});
		}

		$.reset(div);
		$.template_effect(($0) => $.set_text(text_5, $0), [() => tr('pipeline.paramGroup.customParamsDesc')]);
		$.append($$anchor, div);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['pointerdown', 'input', 'change']);
customElements.define('lut-param-node-list', $.create_custom_element(Svelte_param_node_list, { materialSettings: {}, customParams: {} }, [], []));